import { useContext, useState } from "react";
import { ChevronDown, ChevronUp } from "lucide-react";
import { Button } from "../components/ui/button";
import { Card, CardContent } from "../components/ui/card";

import "../singapore.css";
import ScrolltoTop from "./ScrolltoTop";
import Footer from "./Footer";
import Navbar from "./navbar";
import Int2specialform from "./Int2specialform";
import UTMHandler from "./UTMHandler";
import { CurrencyContext } from "./CurrencyContext";
import AutoShowModal from "./AutoShowModal";

const CIcon = {
  USD: '$' ,
  INR:  '₹' ,
  SGD:  'S$' 
};


const itineraryData = [
  { day: "Day 1", port: "SINGAPORE, SINGAPORE", arrive: "", depart: "16:30:00", activity: "EMBARK" },
  { day: "Day 2", port: "PENANG, MALAYSIA", arrive: "	14:30:00", depart: "21:00:00", activity: "DOCKED" },
  { day: "Day 3", port: "PHUKET, THAILAND", arrive: "08:00:00", depart: "	20:00:00", activity: "TENDERED" },
  { day: "Day 4", port: "CRUISING", arrive: "", depart: "", activity: "CRUISING" },
  { day: "Day 5", port: "SINGAPORE, SINGAPORE", arrive: "07:00:00", depart: "", activity: "DEBARK" },
];

const pricingData = {
  USD:[
  { sailingDate: "23-OCT-2025", cruiseFare: "$546", nccf: "$100", tax: "$65", gratuities: "$74", totalCabinFare: "$1570" },
  { sailingDate: "06-NOV-2025", cruiseFare: "$540", nccf: "$100", tax: "$63", gratuities: "$74", totalCabinFare: "$1555" },
  { sailingDate: "13-NOV-2025", cruiseFare: "$437", nccf: "$100", tax: "$63", gratuities: "$74", totalCabinFare: "$1349" },
  { sailingDate: "20-NOV-2025", cruiseFare: "$675", nccf: "$100", tax: "$63", gratuities: "$74", totalCabinFare: "$1824" },
  { sailingDate: "30-NOV-2025", cruiseFare: "$641", nccf: "$100", tax: "$63", gratuities: "$74", totalCabinFare: "$1757" },
  { sailingDate: "24-DEC-2025", cruiseFare: "$871", nccf: "$100", tax: "$77", gratuities: "$74", totalCabinFare: "$2245" },
  { sailingDate: "08-JAN-2026", cruiseFare: "$540", nccf: "$100", tax: "$63", gratuities: "$74", totalCabinFare: "$1554" },
  { sailingDate: "12-JAN-2026", cruiseFare: "$512", nccf: "$100", tax: "$63", gratuities: "$74", totalCabinFare: "$1498" },
  { sailingDate: "22-JAN-2026", cruiseFare: "$540", nccf: "$100", tax: "$63", gratuities: "$74", totalCabinFare: "$1554" },
  { sailingDate: "29-JAN-2026", cruiseFare: "$540", nccf: "$100", tax: "$63", gratuities: "$74", totalCabinFare: "$1554" },
  { sailingDate: "05-FEB-2026", cruiseFare: "$540", nccf: "$100", tax: "$65", gratuities: "$74", totalCabinFare: "$1559" },
  { sailingDate: "23-FEB-2026", cruiseFare: "$507", nccf: "$100", tax: "$66", gratuities: "$74", totalCabinFare: "$1493" },
  { sailingDate: "27-FEB-2026", cruiseFare: "$563", nccf: "$100", tax: "$66", gratuities: "$74", totalCabinFare: "$1606" },
  { sailingDate: "12-MAR-2026", cruiseFare: "$602", nccf: "$100", tax: "$64", gratuities: "$74", totalCabinFare: "$1681" },
],
SGD:[
  { sailingDate: "23-OCT-2025", cruiseFare: "S$680", nccf: "S$130", tax: "S$82", gratuities: "S$101", totalCabinFare: "S$1984" },
  { sailingDate: "06-NOV-2025", cruiseFare: "S$673", nccf: "S$130", tax: "S$79", gratuities: "S$101", totalCabinFare: "S$1965" },
  { sailingDate: "13-NOV-2025", cruiseFare: "S$544", nccf: "S$130", tax: "S$79", gratuities: "S$101", totalCabinFare: "S$1707" },
  { sailingDate: "20-NOV-2025", cruiseFare: "S$841", nccf: "S$130", tax: "S$79", gratuities: "S$101", totalCabinFare: "S$2302" },
  { sailingDate: "30-NOV-2025", cruiseFare: "S$799", nccf: "S$130", tax: "S$79", gratuities: "S$101", totalCabinFare: "S$2218" },
  { sailingDate: "24-DEC-2025", cruiseFare: "S$1086",nccf: "S$130", tax: "S$97", gratuities: "S$101", totalCabinFare: "S$2827" },
  { sailingDate: "08-JAN-2026", cruiseFare: "S$673", nccf: "S$130", tax: "S$78", gratuities: "S$101", totalCabinFare: "S$1964" },
  { sailingDate: "12-JAN-2026", cruiseFare: "S$638", nccf: "S$130", tax: "S$78", gratuities: "S$101", totalCabinFare: "S$1894" },
  { sailingDate: "22-JAN-2026", cruiseFare: "S$673", nccf: "S$130", tax: "S$78", gratuities: "S$101", totalCabinFare: "S$1964" },
  { sailingDate: "29-JAN-2026", cruiseFare: "S$673", nccf: "S$130", tax: "S$78", gratuities: "S$101", totalCabinFare: "S$1964" },
  { sailingDate: "05-FEB-2026", cruiseFare: "S$673", nccf: "S$130", tax: "S$82", gratuities: "S$101", totalCabinFare: "S$1971" },
  { sailingDate: "23-FEB-2026", cruiseFare: "S$631", nccf: "S$130", tax: "S$82", gratuities: "S$101", totalCabinFare: "S$1887" },
  { sailingDate: "27-FEB-2026", cruiseFare: "S$701", nccf: "S$130", tax: "S$82", gratuities: "S$101", totalCabinFare: "S$2028" },
  { sailingDate: "12-MAR-2026", cruiseFare: "S$750", nccf: "S$130", tax: "S$81", gratuities: "S$101", totalCabinFare: "S$2122" },
],
INR:[
  { sailingDate: "23-OCT-2025", cruiseFare: "₹45,288", nccf: "₹8,658", tax: "₹5,428", gratuities: "₹6,703", totalCabinFare: "₹1,32,153" },
  { sailingDate: "06-NOV-2025", cruiseFare: "₹44,822", nccf: "₹8,658", tax: "₹5,251", gratuities: "₹6,703", totalCabinFare: "₹1,30,868" },
  { sailingDate: "13-NOV-2025", cruiseFare: "₹36,230", nccf: "₹8,658", tax: "₹5,251", gratuities: "₹6,703", totalCabinFare: "₹1,13,685" },
  { sailingDate: "20-NOV-2025", cruiseFare: "₹56,011", nccf: "₹8,658", tax: "₹5,275", gratuities: "₹6,703", totalCabinFare: "₹1,53,293" },
  { sailingDate: "30-NOV-2025", cruiseFare: "₹53,213", nccf: "₹8,658", tax: "₹5,279", gratuities: "₹6,703", totalCabinFare: "₹1,47,707" },
  { sailingDate: "24-DEC-2025", cruiseFare: "₹72,328", nccf: "₹8,658", tax: "₹6,449", gratuities: "₹6,703", totalCabinFare: "₹1,88,274" },
  { sailingDate: "08-JAN-2026", cruiseFare: "₹44,822", nccf: "₹8,658", tax: "₹5,206", gratuities: "₹6,703", totalCabinFare: "₹1,30,777" },
  { sailingDate: "12-JAN-2026", cruiseFare: "₹42,491", nccf: "₹8,658", tax: "₹5,222", gratuities: "₹6,703", totalCabinFare: "₹1,26,147" },
  { sailingDate: "22-JAN-2026", cruiseFare: "₹44,822", nccf: "₹8,658", tax: "₹5,206", gratuities: "₹6,703", totalCabinFare: "₹1,30,777" },
  { sailingDate: "29-JAN-2026", cruiseFare: "₹44,822", nccf: "₹8,658", tax: "₹5,206", gratuities: "₹6,703", totalCabinFare: "₹1,30,777" },
  { sailingDate: "05-FEB-2026", cruiseFare: "₹44,822", nccf: "₹8,658", tax: "₹5,437", gratuities: "₹6,703", totalCabinFare: "₹1,31,238" },
  { sailingDate: "23-FEB-2026", cruiseFare: "₹42,025", nccf: "₹8,658", tax: "₹5,455", gratuities: "₹6,703", totalCabinFare: "₹1,25,680" },
  { sailingDate: "27-FEB-2026", cruiseFare: "₹46,687", nccf: "₹8,658", tax: "₹5,491", gratuities: "₹6,703", totalCabinFare: "₹1,35,075" },
  { sailingDate: "12-MAR-2026", cruiseFare: "₹49,950", nccf: "₹8,658", tax: "₹5,367", gratuities: "₹6,703", totalCabinFare: "₹1,41,356" },
]
};

export default function CruiseBooking2() {

const currency = useContext(CurrencyContext);


  const [expandedDays, setExpandedDays] = useState({});
  const [expandedPricing, setExpandedPricing] = useState({});

  const toggleDay = (day) => {
    setExpandedDays(prev => ({ ...prev, [day]: !prev[day] }));
  };

  const togglePricing = (date) => {
    setExpandedPricing(prev => ({ ...prev, [date]: !prev[date] }));
  };

  return (
    <>
   <UTMHandler/>

   <div className="about-navbar">
        <Navbar/>
</div>

    <div className="cruise-container mobile-cruise-container">
      <div className="cruise-header mobile-cruise-header">
        <h1>Int2Cruises Special Offer</h1>
         <h4>Onboard</h4>
        <h3>Royal Caribbean's - Ovation of the Seas</h3>
        <h2>4 NIGHT PENANG AND PHUKET CRUISE</h2>
        {/* <p className="destinations">Singapore • Malaysia • Singapore</p> */}
        {/* <h4>Onboard</h4>
        <h3>Ovation of the Seas</h3> */}
      </div>

      <div className="itinerary-desktop">
        <table>
          <thead>
            <tr>
              <th>Day</th><th>Port</th><th>Arrive</th><th>Depart</th><th>Activity</th>
            </tr>
          </thead>
          <tbody>
            {itineraryData.map((item, i) => (
              <tr key={i} className={i % 2 === 0 ? "even" : "odd"}>
                <td>{item.day}</td><td>{item.port}</td><td>{item.arrive}</td><td>{item.depart}</td><td>{item.activity}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      <div className="itinerary-mobile">
        {itineraryData.map((item, i) => (
          <Card key={i} className="mobile-card">
            <div className="card-header" onClick={() => toggleDay(item.day)}>
              <span>{item.day} {item.port}</span>
              {expandedDays[item.day] ? <ChevronUp size={20} /> : <ChevronDown size={20} />}
            </div>
            {expandedDays[item.day] && (
              <CardContent className="card-content">
                <div><strong>Port:</strong> {item.port}</div>
                <div><strong>Arrive:</strong> {item.arrive || ''}</div>
                <div><strong>Depart:</strong> {item.depart || ''}</div>
                <div><strong>Activity:</strong> {item.activity}</div>
              </CardContent>
            )}
          </Card>
        ))}
      </div>

      <div className="pricing-header">
        <h3>4D - Oceanview Balcony<br />( All inclusive Fare at Double Occupancy )</h3>
       <center ><p style={{marginTop:'-4vh',fontSize:'1.6rem',fontWeight:'700', color:'#72c9c5'}}>IN {currency.currencyCode}({CIcon[currency.currencyCode]})</p></center>
      
      </div>

      <div className="pricing-desktop">
        <table>
          <thead>
            <tr>
              <th>Sailing Date</th><th>Cruise Fare<br /><span>(per person)</span></th>
              <th>NCCF<br /><span>(per person)</span></th><th>Tax<br /><span>(per person)</span></th>
              <th>Gratuities<br /><span>(per person)</span></th><th>Total Cabin Fare</th><th>Action</th>
            </tr>
          </thead>
          <tbody>
            {pricingData[currency.currencyCode].map((item, i) => (
              <tr key={i} className={i % 2 === 0 ? "even" : "odd"}>
                <td>{item.sailingDate}</td><td>{item.cruiseFare}</td><td>{item.nccf}</td>
                <td>{item.tax}</td><td>{item.gratuities}</td><td>{item.totalCabinFare}</td>
                <td>      <Button type="button" class="btn btn-primary" data-bs-toggle="modal" data-bs-target="#staticBackdrop">Book Now</Button></td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      <div className="pricing-mobile">
        {pricingData[currency.currencyCode].map((item, i) => (
          <Card key={i} className="mobile-card">
            <div className="card-header" onClick={() => togglePricing(`${item.sailingDate}-${i}`)}>
              <div>
                <div>Sailing Date</div>
                <div>{item.sailingDate}</div>
              </div>
              <div>
                <div>Total Cabin Fare</div>
                <div>{item.totalCabinFare}</div>
              </div>
              {expandedPricing[`${item.sailingDate}-${i}`] ? <ChevronUp size={20} /> : <ChevronDown size={20} />}
            </div>
            {expandedPricing[`${item.sailingDate}-${i}`] && (
              <CardContent className="card-content">
                <div><strong>Cruise Fare:</strong> {item.cruiseFare} <span>(per person)</span></div>
                <div><strong>NCCF:</strong> {item.nccf} <span>(per person)</span></div>
                <div><strong>Tax:</strong> {item.tax} <span>(per person)</span></div>
                <div><strong>Gratuities:</strong> {item.gratuities} <span>(per person)</span></div>
                      <Button type="button" class="btn btn-primary " data-bs-toggle="modal" data-bs-target="#staticBackdrop">Book Now</Button>
              </CardContent>
            )}
          </Card>
        ))}
      </div>



<div class="modal fade" id="staticBackdrop" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1" aria-labelledby="staticBackdropLabel" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-header">
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <div class="modal-body">
        <Int2specialform leadsource="4Night-Singapore"/>
      </div>
      {/* <div class="modal-footer">
        <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Close</button>
        <button type="button" class="btn btn-primary">Understood</button>
      </div> */}
    </div>
  </div>
</div>

    </div>

    <ScrolltoTop/>
    <AutoShowModal/>
    <Footer/>

     </>
  );
}
